import React from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./subItem.module.scss";
import SonicLink from "../../routing/SonicLink";

type Props = {
  title: string;
  link: string;
  sideBarOpen: boolean;
};

const SubItem: React.FC<Props> = ({ title, link, sideBarOpen }) => {
  const { pathname } = useLocation();

  const titleClass = sideBarOpen
    ? styles["f-subItem__item-title"]
    : `${styles["f-subItem__item-title"]} ${styles["hide"]}`;
  return (
    <SonicLink to={link}>
      <li
        className={
          pathname === link || pathname === link + "/"
            ? `${styles["f-subItem"]} ${styles["isSelect"]}`
            : styles["f-subItem"]
        }
      >
        <div className={styles["f-subItem__item"]}>
          <FontAwesomeIcon icon={["far", "scrubber"]} />
          <span className={titleClass}>{title}</span>
        </div>
      </li>
    </SonicLink>
  );
};

export default SubItem;
